import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsNeuronsWithPricePer100 = () => {
	const { userTags, isLoading } = useUserTags();

	return [userTags.includes(tags.neuronsWithPricePer100), isLoading];
};
